export function sanitizeFontFamily(fontName) {
  if (!fontName) {
    return '';
  }

  // Always return a quoted family name so special characters are valid in CSS
  // Keep the original name (incl. tilde) for exact match with @font-face
  return `'${fontName}'`;
}
